import { useState } from 'react'
import axiosInstant from '../../../api'
import { getBrandTeamEndpoint } from '../../../api/endpoints'
import { BrandTeamMemberData } from '../settings/team/data/type'

export const useGetBrandTeam = (brandId: number) => {
  const [brandTeam, setBrandTeam] = useState<BrandTeamMemberData[]>([])
  const [loading, setLoading] = useState(false)

  const getBrandTeam = async (): Promise<void> => {
    setLoading(true)
    try {
      const response = await axiosInstant.get(getBrandTeamEndpoint(brandId.toString()))
      const { status, data } = response
      if (status === 200) {
        setBrandTeam(data.rows)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      Promise.reject(error)
    }
  }

  return {
    loading,
    getBrandTeam,
    brandTeam,
  }
}
